import LangSwitcher from "./LangSwitcher";

export default function Logo() {
    return (
        <div className="flex justify-between md:justify-center px-6 md:px-4 pt-[58px] md:pt-[96px]">
            <div className="md:hidden">
                <LangSwitcher />
            </div>
            <img src="/images/logo.png" alt="Cosmogas" className="w-1/2 md:w-[240px]" />
        </div>
    )
}